(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });

  function normalizeLilouHeader() {
    const header = document.querySelector('#header-component');
    if (!(header instanceof HTMLElement)) return;

    /* Le script historique de la page d'accueil pouvait remplacer Catalogue par Nos univers.
       On restaure explicitement le 2e lien du menu principal dans le tiroir mobile. */
    const drawerList = header.querySelector('.header__drawer .menu-drawer__menu.has-submenu');
    if (drawerList instanceof HTMLElement) {
      const items = [...drawerList.children].filter((element) => element instanceof HTMLElement);
      const catalogueItem = items[1];
      const catalogueLink = catalogueItem?.querySelector('a.menu-drawer__menu-item--mainlist');

      if (catalogueLink instanceof HTMLAnchorElement) {
        catalogueLink.setAttribute('href', '/collections/all');
        const label = catalogueLink.querySelector('.menu-drawer__menu-item-text');
        if (label) label.textContent = 'Catalogue';
      }
    }

    /* Contact : vraie icône SVG transparente, intégrée au bloc natif Profil / Panier. */
    const rightColumn = header.querySelector('.header__column--right');
    if (!(rightColumn instanceof HTMLElement)) return;

    const headerActions = rightColumn.querySelector('header-actions');
    let contactShortcut = header.querySelector('a.lilou-contact-shortcut');

    if (!(contactShortcut instanceof HTMLAnchorElement)) {
      contactShortcut = document.createElement('a');
      contactShortcut.className = 'lilou-contact-shortcut';
    }

    contactShortcut.setAttribute('href', '/pages/contact');
    contactShortcut.setAttribute('aria-label', 'Contact');
    contactShortcut.setAttribute('title', 'Contact');
    contactShortcut.classList.toggle('is-active', window.location.pathname === '/pages/contact');
    contactShortcut.innerHTML = '<svg class="lilou-contact-glyph" aria-hidden="true" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.75 5.75h16.5v12.5H3.75V5.75Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="m4.25 6.5 7.75 6 7.75-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="visually-hidden">Contact</span>';

    if (headerActions instanceof HTMLElement) {
      if (
        contactShortcut.parentElement !== headerActions ||
        contactShortcut !== headerActions.firstElementChild
      ) {
        headerActions.insertBefore(contactShortcut, headerActions.firstElementChild);
      }
    } else if (contactShortcut.parentElement !== rightColumn) {
      rightColumn.append(contactShortcut);
    }
  }

  function normalizeLilouHome() {
    const selectionsHead = document.getElementById('lilou-selections');
    if (!(selectionsHead instanceof HTMLElement)) return;

    /* Libellés de la page d'accueil alignés avec les univers actuels, sans saut de ligne. */
    const bureauTitle = document.querySelector('.lilou-compact__universe[href="/collections/bureau-teletravail"] strong');
    if (bureauTitle instanceof HTMLElement) bureauTitle.textContent = 'Bureau & Bureautique';

    const sportTitle = document.querySelector('.lilou-compact__universe[href="/collections/auto"] strong');
    if (sportTitle instanceof HTMLElement) sportTitle.textContent = 'Sport & Mobilité';

    /* Sélections du moment et Nouveautés deviennent deux destinations réellement distinctes. */
    let selectionsProducts = selectionsHead.nextElementSibling;
    if (!(selectionsProducts instanceof HTMLElement)) return;
    if (!selectionsProducts.matches('.lilou-compact__products, .lilou-compact__products-empty')) return;

    if (selectionsProducts.id === 'lilou-nouveautes') selectionsProducts.removeAttribute('id');

    let newHead = document.querySelector('.lilou-compact__section-head--new-runtime');
    let newProducts = document.querySelector('.lilou-compact__products--new-runtime, .lilou-compact__products-empty--new-runtime');

    if (!(newHead instanceof HTMLElement)) {
      newHead = document.createElement('div');
      newHead.id = 'lilou-nouveautes';
      newHead.className = 'lilou-compact__section-head lilou-compact__section-head--products lilou-compact__section-head--new-runtime';
      newHead.style.marginTop = '18px';
      newHead.style.paddingTop = '8px';
      newHead.style.borderTop = '1px solid rgba(217, 204, 195, .72)';
      newHead.style.scrollMarginTop = '105px';
      newHead.innerHTML = '<div><span>À DÉCOUVRIR</span><h2>Nouveautés</h2></div><a href="/collections/all?sort_by=created-descending">Voir toutes les nouveautés <span aria-hidden="true">→</span></a>';
      selectionsProducts.insertAdjacentElement('afterend', newHead);
    }

    if (!(newProducts instanceof HTMLElement)) {
      newProducts = selectionsProducts.cloneNode(true);
      newProducts.removeAttribute('id');
      if (newProducts.classList.contains('lilou-compact__products')) {
        newProducts.classList.add('lilou-compact__products--new-runtime');
        newProducts.setAttribute('aria-label', 'Nouveautés');
      } else {
        newProducts.classList.add('lilou-compact__products-empty--new-runtime');
        const strong = newProducts.querySelector('strong');
        const small = newProducts.querySelector('small');
        if (strong) strong.textContent = 'Les nouveautés arrivent bientôt.';
        if (small) small.textContent = 'Les derniers produits publiés apparaîtront ici.';
      }
      newHead.insertAdjacentElement('afterend', newProducts);
    }
  }

  function scheduleHeaderNormalization() {
    window.requestAnimationFrame(function () {
      normalizeLilouHeader();
      normalizeLilouHome();
      window.setTimeout(function () {
        normalizeLilouHeader();
        normalizeLilouHome();
      }, 180);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(scheduleHeaderNormalization, 0);
    });
  } else {
    scheduleHeaderNormalization();
  }

  window.addEventListener('pageshow', scheduleHeaderNormalization);
  document.addEventListener('shopify:section:load', scheduleHeaderNormalization);

  function handleLilouAnchorClick(event) {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest(
      '#header-component .header__drawer header-drawer a.menu-drawer__menu-item[href*="#lilou-"]'
    );
    if (!(link instanceof HTMLAnchorElement)) return;

    let url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (_) {
      return;
    }

    if (!url.hash.startsWith('#lilou-')) return;

    const targetId = decodeURIComponent(url.hash.slice(1));
    const target = document.getElementById(targetId);

    /* Sur une autre page, on laisse le navigateur revenir naturellement à l'accueil. */
    if (!target) return;

    event.preventDefault();

    const drawer = link.closest('header-drawer');
    const details = drawer?.querySelector('#Details-menu-drawer-container');
    const summary = details?.querySelector('summary');

    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
    }

    if (summary) summary.setAttribute('aria-expanded', 'false');

    window.setTimeout(function () {
      if (details) {
        details.classList.remove('menu-open');
        details.removeAttribute('open');
      }

      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search + '#' + targetId);
      }
    }, 180);
  }

  /* Capture : le clic est intercepté avant les gestionnaires internes du tiroir Horizon. */
  document.addEventListener('click', handleLilouAnchorClick, true);
})();